import Vue from 'vue';
import axios from 'axios'
import {Dialog, Toast} from 'vant'
import router from '@/router'
import {getShop, getToken, setToken, setUser} from '@/utils/auth'
// import { loginSource } from '@/utils/business'

Vue.use(Toast)
    .use(Dialog)

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: process.env.VUE_APP_URL,
    // 超时
    timeout: 2000000
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (getToken()) {
            // 让每个请求携带自定义token 请根据实际情况自行修改
            config.headers['Token'] = getToken()
        }
        if (getShop()) {
            // 让每个请求携带自定义token 请根据实际情况自行修改
            config.headers['ShopId'] = getShop()
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// 响应拦截器
// 修复多个接口请求时, 登录超时会弹出多个弹框问题
let msgBoxNum = 0
service.interceptors.response.use(
    res => {
        const code = res.data.code
        const isLoginPath = window.location.pathname === '/login'
        /**
         * 错误编码 为 401、1003 且 msgBoxNum == 0 (没有出现过提示重新登录的弹框)
         */
        if (code === 401) {
            // /login 已是申请页：清 token 即可，勿再弹「请重新登录」造成以为没换页
            setUser('')
            setToken('')
            if (!isLoginPath) {
                Dialog.confirm({
                    title: '提示',
                    message: '请重新登录',
                    showCancelButton: false
                }).then(() => {
                    router.push("/login")
                })
            }
            return Promise.reject('error')
        } else if (code === 403) {
            Dialog.confirm({
                title: '提示',
                message: '无权管理店铺或已删除',
                showCancelButton: false
            }).then(() => {
                router.push("/")
            })
            return Promise.reject('error')
        } else if (code !== 1) {
            /**
             * 错误编码 为 401、1003
             * 出现过重新登录的弹框 msgBoxNum == 1 时 弹错误提示
             * 否则 不弹出错误提示
             */
            if ((code === 401 || code === 1003)) {
                if (msgBoxNum == 1 || isLoginPath) {
                    Notification.error({
                        title: res.data.message || res.data.msg
                    })
                }
                ++msgBoxNum
                // store.dispatch('CLEAR_DATA')
            } else {
                Dialog.alert({
                    message: res.data.msg
                })
            }

            return Promise.reject(res.data)
        } else {
            return res.data
        }
    },error => {
        Dialog.alert({message: '未知错误，请联系管理员'})
        return Promise.reject(error)
    }
)

export default service
